import Vue from 'vue';

Vue.mixin({
    methods: {
        $t: function (key) {
            if (!key) {
                return key;
            }

            if (window.__trans__ && Boolean(window.__trans__[key])) {
                return window.__trans__[key];
            }

            return key;
        },
    },
});

export const i18n = {};
